import {
  addErrandProcessApi,
  queryErrandProcessApi,
  updateErrandProcessApi,
  deleteErrandProcessApi,
  saveWriteOffCodeRecordApi,
  queryWriteOffCodeExportRecordApi,
  queryWOCApi,
  cancelWOCApi,
  setShopownerRuleApi,
  addShopownerApi,
  deleteShopownerApi,
  addShopownerRelShopApi,
  queryShopownerApi,
  queryShopownerRelShopApi,
  getShopownerRelShopListApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加跑腿业务流程
  async addErrandProcessAction(context, param) {
    const res = await addErrandProcessApi(param)
    return res
  },
  //  查询跑腿业务流程
  async queryErrandProcessAction(context, param) {
    const res = await queryErrandProcessApi(param)
    return res
  },
  //  修改跑腿业务流程
  async updateErrandProcessAction(context, param) {
    const res = await updateErrandProcessApi(param)
    return res
  },
  //  删除跑腿业务流程
  async deleteErrandProcessAction(context, param) {
    const res = await deleteErrandProcessApi(param)
    return res
  },
  //  保存核销码导出记录
  async saveWriteOffCodeRecordAction(context, param) {
    const res = await saveWriteOffCodeRecordApi(param)
    return res
  },
  //  核销码导出列表
  async queryWriteOffCodeExportRecordAction(context, param) {
    const res = await queryWriteOffCodeExportRecordApi(param)
    return res
  },
  //  分页查询导出的核销码
  async queryWOCAction(context, param) {
    const res = await queryWOCApi(param)
    return res
  },
  //  作废核销码
  async cancelWOCAction(context, param) {
    const res = await cancelWOCApi(param)
    return res
  },
  //  设置店长规则
  async setShopownerRuleAction(context, param) {
    const res = await setShopownerRuleApi(param)
    return res
  },
  //  添加店长
  async addShopownerAction(context, param) {
    const res = await addShopownerApi(param)
    return res
  },
  //  删除店长
  async deleteShopownerAction(context, param) {
    const res = await deleteShopownerApi(param)
    return res
  },
  //  添加店长关联门店
  async addShopownerRelShopAction(context, param) {
    const res = await addShopownerRelShopApi(param)
    return res
  },
  //  查询店长
  async queryShopownerAction(context, param) {
    const res = await queryShopownerApi(param)
    return res
  },
  //  查询店长关联门店
  async queryShopownerRelShopAction(context, param) {
    const res = await queryShopownerRelShopApi(param)
    return res
  },
  //  获取店长关联门店列表
  async getShopownerRelShopListAction(context, param) {
    const res = await getShopownerRelShopListApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
